import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as Diff from "diff";
import {Change} from "diff";

export interface JsonState {
  before?: string;
  after?: string;
}

@Component({
  selector: 'app-json-difference-modal',
  templateUrl: './json-difference-modal.component.html',
  styleUrls: ['./json-difference-modal.component.scss']
})
export class JsonDifferenceModalComponent implements OnInit {
  public changes: Change[] = [];
  public showChangesOnly: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: JsonState
  ) { }

  public ngOnInit(): void {
    this.changes = Diff.diffJson(
      this.data.before ? JSON.parse(this.data.before) : "",
      this.data.after ? JSON.parse(this.data.after) : "",
    );
  }

  public toggleShowChangesOnly(): void {
    this.showChangesOnly = !this.showChangesOnly;
  }
}
